import React, { Component } from 'react';
import { SizeMe } from 'react-sizeme';
import { EditorState } from 'draft-js';
import _get from 'lodash.get';
import _isEmpty from 'lodash.isempty';


import MasterOutput from './MasterOutput';
import MasterOutputV2 from './MasterOutputV2';

import VoiceOverModal from '../../VoiceOverModal';
import SocialIterations from '../../../../SocialIterations';
import SocialIterationsV2 from '../../../../SocialIterationsV2';
import { SupersizeMyEdit } from '../../Expandable';
import NEW_OUTPUT from '../../../../../common/constants/newOutput';
import { getCurrentVersion } from '../../../../../common/utils';
import { getDefaultDuration, formatAddons } from '../../../utils';

import '../styles/_outputs-and-addons.scss';









































function scrollToNewestOutput() {
  const scrollable = document.querySelector('.outputs-and-addons');

  if (!scrollable) {
    return;
  }

  scrollable.scroll({ top: scrollable.scrollHeight, behavior: 'smooth' });
}

const SECTIONS = {
  CAPTIONS: 'CAPTIONS',
  VOICE_OVER_ARTISTS: 'VOICE_OVER_ARTISTS',
  SOCIAL_ITERATIONS: 'SOCIAL_ITERATIONS'
};

function getDefaultValuesForSection(section) {
  switch (section) {
    case SECTIONS.CAPTIONS:
      return {
        BURN_IN_CAPTIONS: null,
        SRT_CAPTIONS: []
      };
    case SECTIONS.VOICE_OVER_ARTISTS:
      return {
        VOICE_OVER_ARTISTS: []
      };
    default:
      return {};
  }
}

function debounce(func, delay) {
  let timeoutId;

  // eslint-disable-next-line func-names
  return function (...args) {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}

class OutputsAndAddons extends Component


{


  constructor(props) {
    super(props);

    const {
      video: { outputs }
    } = props;

    this.state = {
      outputs,
      showVoiceOverModal: false
    };

    this.debouncedOnOutputsSave = debounce(this.onChangeSocialIteration.bind(this), 500);
  }

  componentDidUpdate(prevProps) {
    const {
      video: { outputs }
    } = prevProps;

    this.syncOutputs(outputs);
  }

  syncOutputs = (prevOuputs) => {
    const {
      video: { outputs }
    } = this.props;
    const shouldUpdateState = outputs && prevOuputs !== outputs;

    if (shouldUpdateState) {
      this.setState({ outputs });
    }
  };

  onOutputsSave = async (outputs) => {
    const { onSaveOutputs } = this.props;
    const { outputs: videoOutputs } = this.state;
    const result = await onSaveOutputs(
      !_isEmpty(outputs) ? outputs : videoOutputs
    );

    const { error, outputs: savedOutputs } = result || {};

    if (error) {
      return;
    }

    this.setState({ outputs: savedOutputs });
  };

  onChangeSocialIteration = async (outputs) => {
    const { onSaveOutputs } = this.props;
    const { outputs: videoOutputs } = this.state;
    await onSaveOutputs(
      !_isEmpty(outputs) ? outputs : videoOutputs
    );
  };

  resetAddonValuesByType = (addonType) => {
    const { outputs } = this.state;
    const { onSaveAddons, outputId: currentOutputId } = this.props;
    const outputIndex = outputs.findIndex((output) => !currentOutputId ? output.isMaster :
    output.outputId === currentOutputId
    );
    const existingOutput = outputs[outputIndex] || {};
    if (addonType === SECTIONS.VOICE_OVER_ARTISTS) {
      existingOutput.voiceOverCustomAssets = [];
      existingOutput.voiceOverInstructions = '';
    }
    const currentVersion = getCurrentVersion(existingOutput);

    const newAddons = {
      ...currentVersion.appliedAddons,
      ...getDefaultValuesForSection(addonType)
    };

    const newVersion = { ...currentVersion, appliedAddons: newAddons };
    const newOutput = { ...existingOutput, versions: [newVersion] };
    const newOutputs = [...outputs];

    newOutputs.splice(outputIndex, 1, newOutput);

    this.setState(
      {
        outputs: newOutputs
      },
      () => onSaveAddons({
        versionId: currentVersion.versionId,
        appliedAddons: formatAddons(newAddons)
      })
    );
  };

  mergeAddon = (outputId, addonType, addonValue) => {
    const { outputs } = this.state;
    const { onSaveAddons } = this.props;

    const outputIndex = outputs.findIndex(
      (output) => output.outputId === outputId
    );
    const existingOutput = outputs[outputIndex];

    const currentVersion = getCurrentVersion(existingOutput);

    const newAddons = {
      ...currentVersion.appliedAddons,
      [addonType]: addonValue
    };
    const newVersion = { ...currentVersion, appliedAddons: newAddons };
    const newOutput = { ...existingOutput, versions: [newVersion] };
    const newOutputs = [...outputs];

    newOutputs.splice(outputIndex, 1, newOutput);

    this.setState(
      {
        outputs: newOutputs
      },
      () => onSaveAddons({
        versionId: currentVersion.versionId,
        appliedAddons: formatAddons(newAddons)
      })
    );
  };

  onChangeAddon = (outputId) => (field) => (
  addonValue) =>
  {
    if (field === 'aspectRatio') {
      const { outputs } = this.state;
      const outputIndex = outputs.findIndex(
        (output) => output.outputId === outputId
      );
      const newOutput = {
        ...outputs[outputIndex],
        aspectRatio: addonValue.value
      };
      const newOutputs = [...outputs];

      newOutputs.splice(outputIndex, 1, newOutput);

      return void this.setState({ outputs: newOutputs }, this.onOutputsSave);
    }

    this.mergeAddon(outputId, field, addonValue);
  };

  onChangeOutputCost = (outputId) => (outputCost) => {
    const { outputs } = this.state;
    const outputIndex = outputs.findIndex(
      (output) => output.outputId === outputId
    );
    const newOutput = {
      ...outputs[outputIndex],
      outputCost: this.formatCost(outputCost)
    };
    const newOutputs = [...outputs];

    newOutputs.splice(outputIndex, 1, newOutput);

    return void this.setState({ outputs: newOutputs }, this.onOutputsSave);
  };

  formatCost = (outputCost) => {
    const { getCurrencySymbol } = this.props;

    return `${getCurrencySymbol()}${outputCost}`;
  };

  updateOutputName = (outputId) => ({
    target: { value }


  }) => {
    const { outputs } = this.state;
    const outputIndex = outputs.findIndex(
      (output) => output.outputId === outputId
    );
    const newOutput = { ...outputs[outputIndex], name: value };
    const newOutputs = [...outputs];

    newOutputs.splice(outputIndex, 1, newOutput);

    return void this.setState({ outputs: newOutputs }, () => {
      this.debouncedOnOutputsSave();
    });
  };

  setInitialOutput = (outputs) => {
    this.setState({ outputs }, this.onOutputsSave);
  };

  createNewOutput = () => {
    setTimeout(() => {
      const { outputs: currentOutputs } = this.state;
      const { video, additionalOutputCost, editingMode } = this.props;
      const newOutputs = [
      ...currentOutputs,
      NEW_OUTPUT({
        video,
        updatedIndex: currentOutputs.length,
        outputCost: additionalOutputCost,
        defaultDuration: getDefaultDuration(video.clips),
        editingMode
      })];


      this.setState({ outputs: newOutputs }, async () => {
        await this.onOutputsSave();

        scrollToNewestOutput();
      });
    }, 1);
  };

  deleteOutput = (index) => {
    const { outputs } = this.state;
    const newOutputs = [...outputs];

    // Find the master output index
    const masterIndex = newOutputs.findIndex((output) => output.isMaster);

    // Map index from SocialIterationsV2 back to original outputs index
    const adjustedIndex = index < masterIndex ? index : index + 1;

    // Ensure we are not deleting the master output
    if (adjustedIndex === masterIndex) {
      return;
    }

    // Remove the selected output
    newOutputs.splice(adjustedIndex, 1);

    const newState = { outputs: newOutputs };

    this.setState(newState, this.onOutputsSave);
  };


  handleNotesChange = (outputId, editorState) => {
    this.setState(({ outputs: prevOutputs }) => {
      const outputs = prevOutputs.map((item) => {
        if (item.outputId === outputId) {
          return { ...item, notes: editorState };
        }
        return item;
      });

      return { outputs };
    }, this.onChangeSocialIteration);
  };

  toggleVoiceOverModal = () => {
    this.setState(({ showVoiceOverModal }) => ({
      showVoiceOverModal: !showVoiceOverModal
    }));
  };

  render() {
    const { outputs, showVoiceOverModal } = this.state;
    const {
      video,
      video: { assetIds: assets, projectType },
      submittedVoiceOverArtists,
      canUpdateVideo,
      hasUpdatePermission,
      getAddonsCost,
      children,
      editingMode,
      outputId: currentOutputId,
      changeSelectedSrtOrBurnIn,
      showAboutInfo,
      hideRushEdit,
      hideBurnInCaptions,
      hideSrtCaption,
      hideCaptions,
      hideVoiceOver,
      hideVoiceOvers,
      hideSocialIterations,
      hideSupersizeMyEdit,
      subHeading,
      isV2Design,
      projectAssets,
      updateProject,
      priceVersion = '',
      openHubSpotConversationsWidget,
      onCaptionsToggleChange
    } = this.props;
    const masterOutputIndex = outputs.findIndex((output) => output.isMaster);
    const outputIndex = outputs.findIndex((output) => !currentOutputId ?
    output.isMaster :
    output.outputId === currentOutputId);
    const { versions = [], latestVersion, outputId, isMaster } = outputs[outputIndex] || {};
    const { appliedAddons = {} } = getCurrentVersion({ versions, latestVersion }) || {};
    const outputCost = getAddonsCost(
      { ADDITIONAL_OUTPUT: { value: 'ADDITIONAL_OUTPUT' } },
      { numberValue: true, isMaster: false }
    );
    const additionalOutputs = [...outputs];

    additionalOutputs.splice(masterOutputIndex, 1);

    return (
      <>
        <VoiceOverModal
          visible={showVoiceOverModal}
          onClose={this.toggleVoiceOverModal}
          priceVersion={priceVersion}
          openHubSpotConversationsWidget={openHubSpotConversationsWidget} />


        <SizeMe>
          {({ size }) =>
          <div className="outputs-and-addons column">
              <div className="outputs-and-addons__section">
                {isV2Design ?
              <MasterOutputV2
                video={video}
                appliedAddons={appliedAddons}
                onChangeAddon={this.onChangeAddon(outputId)}
                canUpdateOutput={canUpdateVideo}
                editingMode={editingMode}
                showAboutInfo={showAboutInfo}
                hideCaptions={hideCaptions}
                hideVoiceOver={hideVoiceOver}
                hideVoiceOvers={hideVoiceOvers}
                onInfoClick={this.toggleVoiceOverModal}
                resetAddonValuesByType={this.resetAddonValuesByType}
                onOutputsSave={this.onOutputsSave}
                projectAssets={projectAssets}
                updateProject={updateProject}
                isV2Design={isV2Design}
                priceVersion={priceVersion}
                onCaptionsToggleChange={onCaptionsToggleChange} /> :


              <MasterOutput
                video={video}
                appliedAddons={appliedAddons}
                onChangeAddon={this.onChangeAddon(outputId)}
                canUpdateOutput={canUpdateVideo}
                toggleVoiceOverModal={this.toggleVoiceOverModal}
                size={size}
                editingMode={editingMode}
                changeSelectedSrtOrBurnIn={changeSelectedSrtOrBurnIn}
                showAboutInfo={showAboutInfo}
                projectType={projectType}
                hideRushEdit={hideRushEdit}
                hideBurnInCaptions={hideBurnInCaptions}
                hideSrtCaption={hideSrtCaption}
                hideVoiceOver={hideVoiceOver}
                hideVoiceOvers={hideVoiceOvers}
                subHeading={subHeading}
                submittedVoiceOverArtists={submittedVoiceOverArtists}
                voiceOverPriceVersion={priceVersion} />}


                {isMaster &&
              !hideSocialIterations && (
              !isV2Design ?
              <SocialIterations
                size={size}
                projectType={projectType}
                assets={assets}
                outputCost={outputCost}
                outputs={outputs}
                hasUpdatePermission={hasUpdatePermission}
                canUpdateVideo={canUpdateVideo}
                onSave={this.onOutputsSave}
                handleNotesChange={this.handleNotesChange}
                onChangeAddon={this.onChangeAddon}
                onChangeCost={this.onChangeOutputCost}
                setInitialOutput={this.setInitialOutput}
                createNewOutput={this.createNewOutput}
                deleteOutput={this.deleteOutput}
                updateOutputName={this.updateOutputName}
                editingMode={editingMode}
                showAboutInfo={showAboutInfo} /> :


              <SocialIterationsV2
                size={size}
                projectType={projectType}
                assets={assets}
                outputCost={outputCost}
                outputs={outputs}
                hasUpdatePermission={hasUpdatePermission}
                canUpdateVideo={canUpdateVideo}
                onSave={this.onOutputsSave}
                handleNotesChange={this.handleNotesChange}
                onChangeAddon={this.onChangeAddon}
                onChangeCost={this.onChangeOutputCost}
                setInitialOutput={this.setInitialOutput}
                createNewOutput={this.createNewOutput}
                deleteOutput={this.deleteOutput}
                updateOutputName={this.updateOutputName}
                editingMode={editingMode} />)}


                {!hideSupersizeMyEdit && editingMode &&
              <SupersizeMyEdit
                supersizeMyEdit={_get(appliedAddons, 'SUPERSIZE_MY_EDIT')}
                onChangeAddon={this.onChangeAddon(outputId)} />}



                {children}
              </div>
            </div>}

        </SizeMe>
      </>);

  }
}

export default OutputsAndAddons;